import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteSlider } from '../../api/apiSliders';
import toast from 'react-hot-toast';

export const useDeleteSlider = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteSlider,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['sliders'] });
            toast.success(data.message || 'Slider deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to delete slider';
            toast.error(errorMessage);
        },
    });
};